import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../config";
import Navbar from "../../components/Navbar/Navbar";

export default function ArAtendimento() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15); // Define quantos itens por página
    const [searchTerm, setSearchTerm] = useState('');

    // Mapeamento de status
    const statusMap = {
        1: 'Despacho Notificação',
        2: 'Relatório',
        3: 'Análise Técnica',
        4: 'Solicitado Documentação',
        5: 'Análise Documental',
        6: 'Análise Encerramento',
        7: 'Deferido',
        8: 'Indeferido',
        9: 'Arquivado',
        10: 'Recebimento do Pedido',
        11: 'Aguardando despacho CGAFI',
        12: 'Análise',
        13: 'Aguardando Reanálise',
        14: 'Protocolado',
        15: 'Aguardando despacho DAFN',
        16: 'Prorrogado'
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/ar`);
                if (!response.ok) {
                    throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
                }
                const result = await response.json();
                setData(result);
            } catch (error) {
                console.error('Erro ao buscar dados:', error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
    };

    // Filtragem dos dados
    const filteredData = data.filter(item => {
        return item.processo ? item.processo.toString().includes(searchTerm) : false;
    });

    // Função de ordenação por status e data
    const sortedData = [...filteredData].sort((a, b) => {
        const statusA = statusMap[a.status] || 'Análise';
        const statusB = statusMap[b.status] || 'Análise';

        const priorityStatus = ['Aguardando despacho DAFN', 'Aguardando despacho CGAFI'];

        const isPriorityA = priorityStatus.includes(statusA);
        const isPriorityB = priorityStatus.includes(statusB);

        // Comparação específica para "Aguardando despacho DAFN"
        if (statusA === 'Aguardando despacho DAFN' && statusB === 'Aguardando despacho DAFN') {
            const dateA = parseDate(a.dataMovimentacao);
            const dateB = parseDate(b.dataMovimentacao);

            // Se as datas forem iguais, compara pelo número do processo
            if (dateA.getTime() === dateB.getTime()) {
                return a.processo.localeCompare(b.processo, 'en', { numeric: true });
            }

            // Caso contrário, compara as datas normalmente
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;
        }

        // Outras verificações de prioridade de status
        if (statusA === 'Aguardando despacho DAFN' && statusB !== 'Aguardando despacho DAFN') return -1;
        if (statusB === 'Aguardando despacho DAFN' && statusA !== 'Aguardando despacho DAFN') return 1;

        if (statusA === 'Aguardando despacho CGAFI' && statusB !== 'Aguardando despacho CGAFI' && statusB !== 'Aguardando despacho DAFN') return -1;
        if (statusB === 'Aguardando despacho CGAFI' && statusA !== 'Aguardando despacho CGAFI' && statusA !== 'Aguardando despacho DAFN') return 1;

        if (statusA === 'Aguardando despacho CGAFI' && statusB === 'Aguardando despacho CGAFI') {
            const dateA = parseDate(a.dataMovimentacao);
            const dateB = parseDate(b.dataMovimentacao);

            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            return a.processo.localeCompare(b.processo, 'en', { numeric: true });
        }

        const dateA = parseDate(a.dataMovimentacao);
        const dateB = parseDate(b.dataMovimentacao);

        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;

        const statusPriority = [
            'Protocolado',
            'Análise',
            'Aguardando Reanálise',
        ];

        const priorityA = statusPriority.indexOf(statusA) !== -1 ? statusPriority.indexOf(statusA) : statusPriority.length;
        const priorityB = statusPriority.indexOf(statusB) !== -1 ? statusPriority.indexOf(statusB) : statusPriority.length;

        if (priorityA < priorityB) return -1;
        if (priorityA > priorityB) return 1;

        return 0;
    });

    // Paginação e exibição dos dados
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(sortedData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    const getStatusBorderClass = (status) => {
        switch (statusMap[status]) {
            case 'Recebimento do Pedido': return 'borda-cinza';
            case 'Protocolado': return 'borda-cinza';
            case 'Análise Técnica':  return 'borda-azul-claro';
            case 'Análise Documental':  return 'borda-azul-escuro';
            case 'Relatório': return 'borda-verde-claro';
            case 'Despacho Notificação':  return 'borda-verde-escuro';
            case 'Análise de Encerramento': return 'borda-roxo';
            case 'Solicitado documentação': return 'borda-vermelho';
            case 'Aguardando despacho DAFN': return 'borda-roxo';
            case 'Aguardando despacho DAFN': return 'borda-roxo';
            case 'Aguardando despacho CGAFI':  return 'borda-cyan';
            case 'Análise': return 'borda-azul-escuro';
            case 'Aguardando Reanálise': return 'borda-laranja';
            case 'Prorrogado': return 'borda-vermei';
            default:
                return ''; // sem borda
        }
    };

    return (
        <div className="home">
            <Navbar searchTerm={searchTerm} onSearchChange={setSearchTerm} />
            <div className="table-container">
                {loading ? (
                    <p>Carregando...</p>
                ) : (
                    <>
                        <table className="data-table">
                            <thead>
                            <tr>
                                <th>Ordem</th>
                                <th>
                                    Processo
                                </th>
                                <th>
                                    Data da Movimentação
                                </th>
                                <th>
                                    Status
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((item, index) => (
                                    <tr key={item.id_ac_atendimento}>
                                        <td data-label="Ordem">{indexOfFirstItem + index + 1}</td>
                                        <td data-label="Processo">{item.processo}</td>
                                        <td data-label="Data da Movimentação">{item.dataMovimentacao}</td>
                                        <td data-label="Status">
                                            <div className={getStatusBorderClass(item.status)}>
                                                {statusMap[item.status] || 'Status desconhecido'}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7">Nenhum credenciamento encontrado!</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button
                                onClick={prevPage}
                                className="page-button"
                                disabled={currentPage === 1}
                            >
                                Anterior
                            </button>
                            {Array.from({length: totalPages}, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => paginate(i + 1)}
                                    className={`page-button ${currentPage === i + 1 ? 'active' : ''}`}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={nextPage}
                                className="page-button"
                                disabled={currentPage === totalPages}
                            >
                                Próxima
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
